module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-14.5eefed60.png";